import {
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosPut,
} from "../axois_V2/axoisWithAuthV2";
import { OrganizationInputTypes } from "../pages/shared/CreateEditOrganization/const";
import { BasePayload, ExtOrganizationType } from "../types";
import { showError, throwError } from "../utils/error";

export const orgBaseURL_V2 = "/organization/v2";

interface GetOrganizationsPayload extends BasePayload {
  search: string;
}
export const getOrganizations_V2 = async (payload: GetOrganizationsPayload) => {
  try {
    const res = await axiosGet(`${orgBaseURL_V2}/all?page=${payload.page || ""}&limit=${payload.limit || ""}&search=${payload.search || ""}`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

interface UpdateOrgPayload extends Partial<ExtOrganizationType> { }

export const updateOrganization_V2 = async (
  organizationId: string,
  payload: any
) => {
  console.log("Calling update API with payload:", payload);
  try {
    const res = await axiosPut(`${orgBaseURL_V2}/${organizationId}`, payload);
    console.log("Update success:", res);
    return res;
  } catch (error) {
    console.error("Update failed:", error);
    showError(error);
    throw error;
  }
};

interface CreateOrgByAdminPayload extends OrganizationInputTypes { }

export const createOrganization_V2 = async (payload: FormData) => {
  try {
    const res = await axiosPost(
      `${orgBaseURL_V2}/register-organization`,
      payload
    );
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getOrganizationById_V2 = async (organizationId: string) => {
  try {
    const res = await axiosGet(`${orgBaseURL_V2}/${organizationId}`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getCitiesOrganizationById_V2 = async (organizationId: string) => {
  try {
    const res = await axiosGet(`${orgBaseURL_V2}/${organizationId}/cities`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const uploadOrgImage_V2 = async (
  organizationId: string,
  payload: FormData
) => {
  try {
    const res = await axiosPut(
      `${orgBaseURL_V2}/update-image/${organizationId}`,
      payload
    );
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const updateOrganizationStatus_V2 = async (
  organizationId: string,
  payload: any
) => {
  try {
    const res = await axiosPatch(
      `${orgBaseURL_V2}/${organizationId}/status`,
      payload
    );
    return res;
  } catch (error) {
    throwError(error);
  }
};
